import { useWebSocket } from '../transport/WebSocketProvider.jsx';
import { States } from '../../../app/src/components/WebSocketClient.js';

// Whether a control command can actually reach the device right now: our WebSocket
// must be Open. A send attempted while the socket is Initial/Reconnecting/Closed is
// silently dropped — WebSocketClient.send has no readyState guard and the provider
// swallows the throw — so the command would look applied (optimistic UI updates)
// yet never leave, and on the device-service path time out silently. Every write
// control gates on this so a disconnected click is prevented rather than lost.
//
// With no socket provider (isolated unit tests) there is no status to read; treat
// as sendable so those tests need not stand a transport up. In the app the provider
// is always present, so this only ever relaxes the gate under test.
export function sendableFromStatus(status) {
  return status == null || status === States.Open;
}

export function useControlsSendable() {
  const ws = useWebSocket();
  const status = ws?.webSocketInfo?.webSocketStatus ?? null;
  return { sendable: sendableFromStatus(status), status };
}

// A short reason for the blocked state, shown next to the disabled control.
export function sendBlockedReason(status) {
  switch (status) {
    case States.Reconnecting: // enum value 'Waiting'
    case States.AttemptingReconnect: // enum value 'Reconnecting'
      return 'Reconnecting…';
    case States.Initial:
      return 'Connecting…';
    default: // Closed / Disabled / anything else non-Open
      return 'You’re offline';
  }
}
